// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.access-denied-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    flex-direction: column;
    background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
    border-radius: 20px;
    margin: 2rem;
    padding: 3rem;
    border: 1px solid rgba(43, 184, 221, 0.2);
  }
  
  .access-denied-icon {
    font-size: 4rem;
    margin-bottom: 1rem;
  }
  
  .access-denied-title {
    color: #2bb8dd;
    margin-bottom: 1rem;
    font-size: 2rem;
  }
  
  .access-denied-message {
    color: #a0a0a0;
    text-align: center;
    font-size: 1.1rem;
  }
  
  .access-denied-button {
    margin-top: 2rem;
    padding: 1rem 2rem;
    background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    transition: transform 0.2s ease;
  }
  
  .access-denied-button:hover {
    transform: translateY(-2px);
  }`, "",{"version":3,"sources":["webpack://./src/components/AccessDenied.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,6DAA6D;IAC7D,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B","sourcesContent":[".access-denied-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 60vh;\n    flex-direction: column;\n    background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n    border-radius: 20px;\n    margin: 2rem;\n    padding: 3rem;\n    border: 1px solid rgba(43, 184, 221, 0.2);\n  }\n  \n  .access-denied-icon {\n    font-size: 4rem;\n    margin-bottom: 1rem;\n  }\n  \n  .access-denied-title {\n    color: #2bb8dd;\n    margin-bottom: 1rem;\n    font-size: 2rem;\n  }\n  \n  .access-denied-message {\n    color: #a0a0a0;\n    text-align: center;\n    font-size: 1.1rem;\n  }\n  \n  .access-denied-button {\n    margin-top: 2rem;\n    padding: 1rem 2rem;\n    background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: 600;\n    transition: transform 0.2s ease;\n  }\n  \n  .access-denied-button:hover {\n    transform: translateY(-2px);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
